var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyDropCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5135_206)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F7F1EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "#FFE900"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5135_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 31.2069C56 32.7001 54.7076 34 53 34C51.2924 34 50 32.7001 50 31.2069C50 30.3519 50.3926 28.6983 51.0766 27.2433C51.414 26.5255 51.7923 25.9222 52.1736 25.5143C52.5677 25.0926 52.8477 25 53 25C53.1523 25 53.4323 25.0926 53.8264 25.5143C54.2077 25.9222 54.586 26.5255 54.9234 27.2433C55.6074 28.6983 56 30.3519 56 31.2069Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4784 25.8517C45.2466 24.6695 42.7015 24 40 24C31.1634 24 24 31.1634 24 40C24 48.8366 31.1634 56 40 56C48.8366 56 56 48.8366 56 40C56 39.1434 55.9327 38.3025 55.8031 37.4823C55.193 37.719 54.5376 37.8807 53.8516 37.9545C53.9494 38.6222 54 39.3052 54 40C54 47.732 47.732 54 40 54C32.268 54 26 47.732 26 40C26 32.268 32.268 26 40 26C42.4586 26 44.7691 26.6338 46.7772 27.7468C46.9773 27.1212 47.2124 26.4818 47.4784 25.8517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_5135_206",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 39.5C49 38.5717 48.6313 37.6815 47.9749 37.0251C47.3185 36.3687 46.4283 36 45.5 36C44.5717 36 43.6815 36.3687 43.0251 37.0251C42.3687 37.6815 42 38.5717 42 39.5L43.5209 39.5C43.5209 38.9751 43.7294 38.4717 44.1006 38.1006C44.4717 37.7294 44.9751 37.5209 45.5 37.5209C46.0249 37.5209 46.5283 37.7294 46.8994 38.1006C47.2706 38.4717 47.4791 38.9751 47.4791 39.5H49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49 39.5C49 38.5717 48.6313 37.6815 47.9749 37.0251C47.3185 36.3687 46.4283 36 45.5 36C44.5717 36 43.6815 36.3687 43.0251 37.0251C42.3687 37.6815 42 38.5717 42 39.5L43.5209 39.5C43.5209 38.9751 43.7294 38.4717 44.1006 38.1006C44.4717 37.7294 44.9751 37.5209 45.5 37.5209C46.0249 37.5209 46.5283 37.7294 46.8994 38.1006C47.2706 38.4717 47.4791 38.9751 47.4791 39.5H49Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-4-inside-1_5135_206)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_5135_206",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 39.5C37 38.5717 36.6313 37.6815 35.9749 37.0251C35.3185 36.3687 34.4283 36 33.5 36C32.5717 36 31.6815 36.3687 31.0251 37.0251C30.3687 37.6815 30 38.5717 30 39.5L31.5129 39.5C31.5129 38.973 31.7223 38.4676 32.0949 38.0949C32.4676 37.7223 32.973 37.5129 33.5 37.5129C34.027 37.5129 34.5324 37.7223 34.9051 38.0949C35.2777 38.4676 35.4871 38.973 35.4871 39.5H37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 39.5C37 38.5717 36.6313 37.6815 35.9749 37.0251C35.3185 36.3687 34.4283 36 33.5 36C32.5717 36 31.6815 36.3687 31.0251 37.0251C30.3687 37.6815 30 38.5717 30 39.5L31.5129 39.5C31.5129 38.973 31.7223 38.4676 32.0949 38.0949C32.4676 37.7223 32.973 37.5129 33.5 37.5129C34.027 37.5129 34.5324 37.7223 34.9051 38.0949C35.2777 38.4676 35.4871 38.973 35.4871 39.5H37Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-5-inside-2_5135_206)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_5135_206",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5494 47.9382C46.8363 46.703 45.8237 45.667 44.605 44.9258C43.3863 44.1847 42.0007 43.7621 40.5758 43.6971C39.1509 43.632 37.7325 43.9266 36.4514 44.5537C35.1702 45.1808 34.0675 46.1202 33.2447 47.2854L34.566 48.2184C35.2322 47.2749 36.1251 46.5143 37.1625 46.0065C38.1998 45.4988 39.3483 45.2602 40.502 45.3129C41.6558 45.3655 42.7777 45.7077 43.7645 46.3078C44.7513 46.908 45.5712 47.7468 46.1487 48.747L47.5494 47.9382Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.5494 47.9382C46.8363 46.703 45.8237 45.667 44.605 44.9258C43.3863 44.1847 42.0007 43.7621 40.5758 43.6971C39.1509 43.632 37.7325 43.9266 36.4514 44.5537C35.1702 45.1808 34.0675 46.1202 33.2447 47.2854L34.566 48.2184C35.2322 47.2749 36.1251 46.5143 37.1625 46.0065C38.1998 45.4988 39.3483 45.2602 40.502 45.3129C41.6558 45.3655 42.7777 45.7077 43.7645 46.3078C44.7513 46.908 45.5712 47.7468 46.1487 48.747L47.5494 47.9382Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-6-inside-3_5135_206)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5135_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5135_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyDropCircle);
export default __webpack_public_path__ + "static/media/smiley-drop-circle.fb79d080cf319cd4e2e7ac558e4b8d0a.svg";
export { ForwardRef as ReactComponent };